<app-header [title]="title" [subtitle]="subtitle"></app-header>
<main>
  <div class="containero">
    <div *ngIf="project.selectedMosaic" class="tabs">
      <span class="plaster" [ngClass]="{'active': !mosaicTab}"   (click)="selectPlaster()">Tynk silikatowy</span>
      <span class="mosaic" [ngClass]="{'active': mosaicTab}"   (click)="selectMosaic()">Tynk mozaikowy</span>
    </div>
    <div class="plaster calculator" [ngClass]="{'not-active': mosaicTab}">
      <div class="row">
        <div class="col-sm-4 col-xs-12 ">
          <img src="{{plaster.imageFile}}" class="img-fluid cpic" alt="">
          <h3><b>{{plaster.name}}</b></h3>
        </div>
        <div class="col-sm-8 col-xs-12">
          <div class="form">
            <div class="info">

              <h4  >Wybierz granulację tynku:</h4>
              <div class="options">
                <div class="option" (click)="onSelectPlaster(1)"
                     *ngIf="plaster.knaufPlaster == KnaufPlaster.KnaufConniSBaranek">
                  <span [class.selected]="selectedPlaster==1"></span>
                  <label  >ziarno 1&nbsp;mm</label>
                </div>
                <div class="option" (click)="onSelectPlaster(2)">
                  <span [class.selected]="selectedPlaster==2"></span>
                  <label  >ziarno 1,5&nbsp;mm</label>
                </div>
                <div class="option" (click)="onSelectPlaster(3)">
                  <span [class.selected]="selectedPlaster==3"></span>
                  <label  >ziarno 2&nbsp;mm</label>
                </div>
              </div>
              <p><span  >Podaj pole powierzchni ocieplonej elewacji:</span><input (keyup)="onPlasterChange($event)"
                                                                                     name="powierzchnia" value="{{plasterMeters}}" /><span>m<sup>2</sup></span></p>

            </div>
            <div class="form-footer">
              <div   class="left">Wynik</div>
              <div class="right">
                <h4  >Do wykończenia elewacji potrzebujesz</h4>
                <div class="sum">
                  <span class="countero">{{plasterBucket}}</span><span id="count-plaster-name">opakowań tynku
                  {{plaster.shortName}}</span></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div *ngIf="project.selectedMosaic" class="mosaic calculator" [ngClass]="{'not-active': !mosaicTab}">


      <div class="row">
        <div class="col-sm-4 col-xs-12 ">
          <img src="assets/photos/wiadro_mosaic.png" class="img-fluid cpic" alt="">
          <h3><b>Tynk mozaikowy Knauf</b></h3>
        </div>
        <div class="col-sm-8 col-xs-12">
          <div class="form">
            <div class="info">

              <h4  >Wybierz granulację tynku:</h4>
              <div class="options">
                <div *ngIf="selectedMosaic == 1">
                  <span class="selected"></span>
                  <label  >kruszywo 0,8 - 1,2 mm</label>
                </div>
                <div *ngIf="selectedMosaic == 2">
                  <span class="selected"></span>
                  <label  >kruszywo 1,0 - 1,6 mm</label>
                </div>
              </div>
              <p><span  >Podaj pole powierzchni ocieplonej elewacji:</span><input (keyup)="onMosaicChange($event)"
                                                                                     name="powierzchnia" value="{{mosaicMeters}}" /><span>m<sup>2</sup></span></p>
              <div class="form-footer">
                <div   class="left ">Wynik</div>
                <div class="right">
                  <h4  >Do wykończenia elewacji potrzebujesz</h4>
                  <div class="sum"><span class="countero">{{mosaicBucket}}</span><span id="count-mosaic-name">opakowań tynku mozaikowego</span></div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


    </div>
    </div>
</main>
<app-footer [prev]="prev" [nextEvent]="true" (clickNext)="onNextClick($event)"></app-footer>

<jw-modal id="confirmation-dlg">
  <div class="messagebox">
    <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
                                         (click)="closeModal()"></button>
    <p  >Podana ilość tynku stanowi jedynie wartość orientacyjną i jest sumą dla wszystkich kolorów tynku. Przed
      zakupem materiału skonsultuj otrzymany wynik z wykonawcą, którego zatrudniłeś do wykonania prac.</p>
    <div class="buttons">
      <button class="btn btn-primary"  (click)="accept()">Dalej</button>

    </div>
  </div>
</jw-modal>
